import './fontSize.css';

document.addEventListener('DOMContentLoaded', () => {
    const zoomInBtn = document.querySelector('.font-size-controls #zoom-in');
    const zoomOutBtn = document.querySelector('.font-size-controls #zoom-out');
    const zoomResetBtn = document.querySelector('.font-size-controls #zoom-reset');

    let storedScale = parseFloat(localStorage.getItem('fontSizeScale'))
    let scale = Number.isFinite(storedScale) ? storedScale : 1;

    function updateFontScale(newScale) {
        document.documentElement.style.setProperty('--font-size-scale', newScale);
        localStorage.setItem('fontSizeScale', newScale);
    }

    updateFontScale(scale);

    function increaseFont() {
        scale += 0.1;
        updateFontScale(scale);
    }

    function decreaseFont() {
        scale = Math.max(0.5, scale - 0.1);
        updateFontScale(scale);
    }

    function resetFont() {
        scale = 1;
        updateFontScale(scale);
    }

    zoomInBtn?.addEventListener('click', increaseFont);
    zoomOutBtn?.addEventListener('click', decreaseFont);
    zoomResetBtn?.addEventListener('click', resetFont);

    [zoomInBtn, zoomOutBtn, zoomResetBtn].forEach(btn => {
        if (!btn) {
            return;
        }

        btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                btn.click();
            }
        });
    });
});